module.exports = __webpack_public_path__ + "img/googlegke.deaff14c.svg";